module.exports = __webpack_public_path__ + "img/5.3c78a258.jpg";